import { useState } from "react";

export const useManOfTheMatchState = () => {
  const [awards, setAwards] = useState([]);
  const [filteredAwards, setFilteredAwards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeFilter, setActiveFilter] = useState("all");

  return {
    awards,
    setAwards,
    filteredAwards,
    setFilteredAwards,
    loading,
    setLoading,
    searchTerm,
    setSearchTerm,
    activeFilter,
    setActiveFilter,
  };
};